import { createI18n } from 'vue-i18n';
import i18next from 'i18next';

const messages = {
  en: {
    welcome_message: 'Welcome'
    // Add more translations here
  }
  // Add other languages here
};

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: i18next.language || 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
